import { Theme } from '@emotion/react';
import React, { FunctionComponent } from 'react';

import { AvatarImage, AvatarImageProps } from 'omakase';
import { avatarButton, avatarButtonSelected, avatarElementBase } from './avatarCssDefs';

export type AvatarButtonCoreProps = Omit<React.HTMLProps<HTMLButtonElement>, 'size' | 'type'> &
  AvatarImageProps;

export const AvatarButtonCore: FunctionComponent<AvatarButtonCoreProps> = ({
  alt,
  selected,
  size,
  src,
  ...rest
}) => {
  return (
    <button
      css={(theme: Theme) => [
        avatarElementBase(size),
        avatarButton(theme),
        selected && avatarButtonSelected(theme),
      ]}
      {...rest}
    >
      <AvatarImage alt={alt} size={size} src={src} />
    </button>
  );
};
